import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { StyledLink } from "pro-features/styled components/StyledLink/src/StyledLink";
import I18n from "pro-features/components/WithTranslation/src/I18n";
const { carbon, bluegrey, blue } = colorsPalettes;

export const StyledButton = styled(IconButton)`
    ${setFontVariant("button", carbon[0])};
`;

const StyledTooltipHeader = styled(I18n)`
    ${setFontVariant("listItem4", bluegrey[100])};
`;

const StyledTooltipLink = styled(StyledLink)`
    display: flex;
    ${setFontVariant("tooltip", blue[300])};
`;
